import React, { useRef, useState } from "react";
import { SlOptions } from "react-icons/sl";
// import { useNavigate } from "react-router-dom";
import Check from "../../assets/icons/Group.svg";
import Delete from "../../assets/icons/delete-bin-5-line.svg";
import moment from "moment";
import { DeleteModal } from "../modals/donemodal";

const UsersTable = ({ data }) => {
	const [openPopup, setOpenPopup] = useState(null),
	[modal,setModal]=useState<any>("")
	// const navigate = useNavigate();
	const popupRef = useRef(null);
	const togglePopup = id => {
		if (openPopup === id) {
			setOpenPopup(null);
		} else {
			setOpenPopup(id);
		}
	};
	const options = [
		{
			icon: Check,
			name: "edit role",
			color: "#505666",
			action: () => {},
			// action: () => navigate(`/tools/${openPopup}`),
		},
		{
			icon: Delete,
			name: "remove account",
			color: "#C5292A",
			action: (sta) => {setModal(sta);setOpenPopup(null)},
		},
	];

	return (
		<div>
			<table className="table-auto w-full">
				<thead className="grid grid-cols-5 capitalize items-center bg-[#F2FBFF] text-base font-medium text-da-blue-700 h-11 w-full px-8">
					<th className="text-left">Company</th>
					<th className="text-left">Email address</th>
					<th className="text-left">Name</th>
					<th className="text-left">role</th>
					<th className="text-left">Date added</th>
				</thead>
				<tbody>
					{data?.map((it, i) => (
						<tr className="grid grid-cols-5 capitalize text-left px-8 text-base font-normal text-da-blue-800 items-center bg-transparent border-b border-b-[#eee]">
							<td className="h-14 flex gap-4 items-center">
								<input
									type="checkbox"
									name=""
									className="form-checkbox size-5 border border-[#ccc]"
									id=""
								/>
								<span className="text-base font-normal first-letter:uppercase text-da-blue-800">
									{it?.name}
								</span>
							</td>
							<td className="lowercase">{it?.user?.email}</td>
							<td className="first-letter:uppercase">
								{it?.user?.firstName} {it?.user?.lastName}
							</td>
							<td className="first-letter:uppercase">{it?.privilege}</td>
							<td className=" col-span-1 flex justify-between items-center first-letter:uppercase">
								<span>{moment(it?.createdAt).format("DD-MM-YYYY")}</span>
								<div className="relative">
									<SlOptions
										onClick={() => togglePopup(i)}
										className="cursor-pointer"
										color="#404040"
									/>
									{openPopup === i && (
										<div
											style={{
												boxShadow: "0px 10px 40px 0px #0000001A",
											}}
											className="absolute right-0 top-4 mt-2 p-5 bg-white shadow-lg rounded z-10">
											<div className="space-y-3">
												{options?.map((op, idx) => (
													<button
														onClick={() => (op?.action ? op?.action(it) : {})}
														ref={popupRef}
														className={`h-9 px-3 whitespace-nowrap ${
															idx === 0 && "bg-[#F4F4F4]"
														} bg-transparent flex gap-3 rounded-lg items-center`}>
														<img src={op?.icon} alt="" className="" />
														<span
															style={{
																color: op?.color,
															}}
															className="font-normal capitalize text-sm">
															{op?.name}
														</span>
													</button>
												))}
											</div>
										</div>
									)}
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			{modal && (
				<DeleteModal
					page={"User"}
					handleClose={() => setModal("")}
					path={"/tools"}
				/>
			)}
		</div>
	);
};

export const PendingUsersTable = ({ data }) => {
	const [openPopup, setOpenPopup] = useState(null);
	// const navigate = useNavigate();
	const popupRef = useRef(null);
	const togglePopup = id => {
		if (openPopup === id) {
			setOpenPopup(null);
		} else {
			setOpenPopup(id);
		}
	};
	const options = [
		{
			icon: Check,
			name: "resend invite",
			color: "#505666",
			action: () => {},
			// action: () => navigate(`/tools/${openPopup}`),
		},
		{ icon: Delete, name: "revoke invite", color: "#C5292A" },
	];

	return (
		<div>
			<table className="table-auto w-full">
				<thead className="grid grid-cols-4 items-center capitalize bg-[#F2FBFF] text-base font-medium text-da-blue-700 h-11 w-full px-8">
					<th className="text-left">Email address</th>
					<th className="text-left">Name</th>
					<th className="text-left">role</th>
					<th className="text-left">Status</th>
				</thead>
				<tbody>
					{data?.map((it, i) => (
						<tr className="grid grid-cols-4 text-left capitalize px-8 text-base font-normal text-da-blue-800 items-center bg-transparent border-b border-b-[#eee]">
							<td className="h-14 flex gap-4 items-center">
								<input
									type="checkbox"
									name=""
									className="form-checkbox size-5 border border-[#ccc]"
									id=""
								/>
								<span className="text-base font-normal text-da-blue-800 lowercase">
									{it?.user?.email}
								</span>
							</td>
							<td className="first-letter:uppercase">
								{it?.user?.firstName} {it?.user?.lastName}
							</td>
							<td className="first-letter:uppercase">{it?.privilege}</td>
							<td className=" col-span-1 flex justify-between items-center first-letter:uppercase">
								<button className="h-9 w-28 bg-[#FEFCE8] text-[#CA8A04] text-sm font-medium inter capitalize">
									{it?.statusText}
								</button>
								<div className="relative">
									<SlOptions
										onClick={() => togglePopup(i)}
										className="cursor-pointer"
										color="#404040"
									/>
									{openPopup === i && (
										<div
											style={{
												boxShadow: "0px 10px 40px 0px #0000001A",
											}}
											className="absolute right-0 top-4 mt-2 p-5 bg-white shadow-lg rounded z-10">
											<div className="space-y-3">
												{options?.map((op, idx) => (
													<button
														onClick={op?.action}
														ref={popupRef}
														className={`h-9 px-3 whitespace-nowrap ${
															idx === 0 && "bg-[#F4F4F4]"
														} bg-transparent flex gap-3 rounded-lg items-center`}>
														<img src={op?.icon} alt="" className="" />
														<span
															style={{
																color: op?.color,
															}}
															className="font-normal capitalize text-sm">
															{op?.name}
														</span>
													</button>
												))}
											</div>
										</div>
									)}
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default UsersTable;
